require('../../../modules/es.array.join');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').join;
